import {
  Drawer,
  Button,
  Portal,
  Icon,
  IconButton,
  Flex,
} from '@chakra-ui/react';
import { BiLogOut } from 'react-icons/bi';
import { FaBars } from 'react-icons/fa6';
import { useAuth } from '@/context/AuthProvider';
import { useState } from 'react';
import NavigationMenu from './NavigationMenu';
import OrgSwitcher from './OrgSwitcher';
import { useTranslation } from 'react-i18next';
import { useUserQuery } from '@/api/user/useUserQuery';

function MobileDrawer() {
  const { logout } = useAuth();
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const { data: user } = useUserQuery();
  const hasOrganization =
    user?.organization !== null && user?.organization !== undefined;

  return (
    <Drawer.Root
      placement="start"
      open={open}
      onOpenChange={(e) => setOpen(e.open)}
    >
      <Drawer.Trigger asChild>
        <IconButton variant="ghost" size="lg" aria-label="Open navigation menu">
          <FaBars />
        </IconButton>
      </Drawer.Trigger>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content background="gray.800">
            <Drawer.Body>
              <Flex
                py={4}
                flexDirection="column"
                justifyContent="space-between"
                height="100%"
              >
                <Flex flexDirection="column">
                  {hasOrganization && (
                    <OrgSwitcher onSwitch={() => setOpen(false)} />
                  )}
                  <NavigationMenu onItemClick={() => setOpen(false)} />
                </Flex>
                <Button
                  variant="ghost"
                  onClick={() => logout()}
                  mt={8}
                  w="full"
                  justifyContent="flex-start"
                  color="white"
                  _hover={{
                    bg: 'gray.700',
                  }}
                >
                  <Icon as={BiLogOut} mr={3} boxSize={5} />
                  {t('logout')}
                </Button>
              </Flex>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}

export default MobileDrawer;
